module.exports = __webpack_public_path__ + "assets/img/1611589449039_.pic_hd.d2b08f8f.jpg";